import { FC } from 'react';
import { SearchTrigger, Text, TextTabScrollable } from '@croquiscom-pvt/zds';

import {
  BannerGroup,
  ComponentItem,
  FilterParam,
  GrouppedComponentListMap,
  ShopInfo,
  TextCategoryList,
} from '@domains/storehome-common';

import { Divider, ScrollWrap, SearchTriggerWrap, TextTabWrapper } from '../components/Main.styled';
import { useMainService } from '../services/useMainService';

export interface StoreHomeViewProps {
  shop_info: ShopInfo;
  is_header_solid?: boolean;
  banner_group: BannerGroup | null;
  category_list: TextCategoryList[];
  is_preview?: boolean;
  renderMainBanner: (props: {
    shop_id: string;
    banner_group: BannerGroup | null;
    is_preview?: boolean;
  }) => React.ReactNode;
  renderShopInformation: (props: { shop_info: ShopInfo; is_cover_view: boolean }) => React.ReactNode;
  renderComponentList: (props: {
    type: 'store' | 'category' | 'zigzin-shipping';
    params: {
      shop_id: string;
      category_id?: string | null;
      check_button_item_ids?: string[];
      sub_filter_id_list?: string[];
    };
    components: GrouppedComponentListMap;
    component_list: Array<ComponentItem | null>;
    is_fetching: boolean;
    error?: unknown;
    has_next_page?: boolean;
    is_selected?: boolean;
    onFetchNextPage: () => void;
    onParamsChange: (params: FilterParam) => void;
    refetch?: () => void;
  }) => React.ReactNode;
}

export const DefaultMainContainer: FC<React.PropsWithChildren<StoreHomeViewProps>> = ({
  shop_info,
  banner_group,
  category_list,
  is_preview,
  renderMainBanner,
  renderShopInformation,
  renderComponentList,
}) => {
  const {
    params,
    shop_id,
    shop_name,
    applied_banner_group,
    categories,
    component_list_props,
    exists_banner,
    onParamsChange,
    fetchNextPage,
    handleCategoryClick,
    handleImpressionCategory,
    handleSearchClick,
  } = useMainService({ shop_info, banner_group, is_preview, category_list });
  return (
    <ScrollWrap>
      <TextTabWrapper>
        <TextTabScrollable
          defaultValue={null}
          items={categories}
          onChange={handleCategoryClick}
          hideBorderBottom
          onImpression={handleImpressionCategory}
          impressionMode='once'
          fullWidth={false}
        />
      </TextTabWrapper>
      {renderMainBanner({ shop_id, banner_group: applied_banner_group, is_preview })}
      {renderShopInformation({ shop_info, is_cover_view: exists_banner })}
      <Divider />
      {shop_info.show_search_button && (
        <SearchTriggerWrap>
          <SearchTrigger onClick={handleSearchClick} color='textSecondary' borderColor='borderStrong'>
            <Text color='textStrong' as='span' variant='Body_15_Multiline_Bold'>
              {shop_name}
            </Text>{' '}
            내에서 검색해보세요.
          </SearchTrigger>
        </SearchTriggerWrap>
      )}
      {renderComponentList({
        type: 'store',
        params,
        ...component_list_props,
        onFetchNextPage: fetchNextPage,
        onParamsChange: onParamsChange,
      })}
    </ScrollWrap>
  );
};
